
const api = {
  base_url: 'https://vajehnegar.afraos.ir/api/v1',
  register: '/user/register',
  login: '/user/login',
  user_profile: '/user/profile',
  all_words: '/word/all'
}

export default api
